import React, { useMemo } from "react"
import TableContainer from "components/tables/TableContainer"
import { useHistory } from "react-router-dom"
import { Button } from "reactstrap"


const Table = ({ content, page, size, count, setSize, setPage }) => {
  const history = useHistory()

  const listDataTable = useMemo(() => {
    if (!content) return []
    return content.map((v, i) => ({
      id: v.id,
      categoryName: v?.categoryName,
      productName: v?.productName || "-",
      setAlready: v?.setAlready,
    }))
  }, [content])

  const columns = useMemo(
    () => [
      {
        Header: "商品カテゴリ",
        accessor: "categoryName",
        defaultCanSort: false,
        // Cell: ({ cell }) => {
        //   return (
        //     <div
        //       style={{ color: "#556ee6", cursor: "pointer" }}
        //       onClick={() =>
        //         history.push(
        //           `/order-sheet-creation/form?id=${cell.row.original.id}`
        //         )
        //       }
        //     >
        //       {cell.row.original.categoryName}
        //     </div>
        //   )
        // },
      },
      {
        Header: "商品名",
        accessor: "productName",
        defaultCanSort: false,
      },
      {
        Header: "設定済み",
        accessor: "setAlready",
        defaultCanSort: false,
        Cell: ({ cell }) => {
          return (
            <span>
              {cell.row.original.setAlready === true ? "済み" : "未設定"}
            </span>
          )
        },
      },
      {
        Header: "",
        accessor: "id",
        defaultCanSort: false,
        Cell: ({ cell }) => {
          return (
            <div className="d-flex align-items-center justify-content-center w-full">

            <Button
              className="button"
              onClick={() =>
                history.push(
                  `/order-sheet-creation/form?id=${cell.row.original.id}`
                )
              }
            >
              詳細
            </Button>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <TableContainer
      page={page + 1}
      size={size}
      count={count}
      setPageSize={val => setSize(val)}
      setParams={params => setPage(params.page)}
      columns={columns}
      data={listDataTable}
      pagination
    />
  )
}

export default Table
